export default {
  date: 'November 20, 2024',
  title: 'Update: New Style "Elegance"',
  description: 'Create timeless and sophisticated property visuals',
  id: 'style-elegance',
  jsx: () => (
    <div class='novelty__text'>
      <p>Step into a world of sophistication and grace with our newest design style — Elegance!</p>
      <p>We are present style Elegance. This timeless style combines refined simplicity with carefully selected materials to create interiors that are both inviting and unforgettable.</p>
      <p>
        <b>Why "Elegance"?</b>
      </p>
      <p>
        The Elegance style is perfect for showcasing properties in their best light. Soft neutral tones, natural materials, and graceful forms come together to create an atmosphere of comfort and sophistication. This design not only highlights the beauty of a space but also allows potential buyers
        to immediately picture themselves living there, making it easier to secure a sale.
      </p>
      <b>Ready to try it?</b>
      <p>You can now select the Elegance style when ordering property visualizations on our website. Add timeless beauty and charm to your projects, helping buyers connect with your property on an emotional level.</p>
      <b>How to Order?</b>
      <p class='margin-none'>
        <b>Step 1: </b>
        Visit the storefront section at
        <a href='https://getfloorplan.com/#showcase'> getfloorplan.com</a>
      </p>
      <p class='margin-none'>
        <b>Step 2: </b>
        Choose a set with AI materials
      </p>
      <p>
        <b>Step 3: </b>
        On the second step of the “AI set-up” process, select the “Elegance” interior style under the “Select interior style” heading
      </p>
      <p>With its classic appeal and universal charm, Elegance is designed to meet modern buyers' expectations while adding a sense of refinement to your property. Showcase the true potential of your space and boost sales with Elegance visualizations from Getfloorplan.</p>
    </div>
  ),
  thumb: 'news/32.webp',
};
